import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CircledInfoIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      height={getDefaultHeight(svgProps, 32)}
      {...svgProps}
      fill={color}
    >
      <path d="M16 0c-8.832 0-16 7.168-16 16s7.168 16 16 16c8.832 0 16-7.168 16-16s-7.168-16-16-16zM18.144 26.208h-4.288v-14.912h4.32v14.912zM18.144 9.952h-4.288v-4.16h4.32v4.16z"></path>
    </SVG>
  );
};
